<div class="card news-section">
  <div class="card-header">
    <h3 class="card-title">{{ 'news.header' | translate }}</h3>
</div>    
  
  <div class="border-bottom p-3">
    <app-category-list (categorySelected)="companyList.onCategorySelected($event)"></app-category-list>
  </div>

  <div class="card-body card-body-scrollable border-0 p-0">
    <app-company-news-list #companyList></app-company-news-list>
  </div>

</div>
